var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1363 2.49622C16.9488 1.74622 16.355 1.15247 15.6363 0.964966C14.2925 0.589966 8.98004 0.589966 8.98004 0.589966C8.98004 0.589966 3.63629 0.589966 2.29254 0.964966C1.57379 1.15247 0.980042 1.74622 0.792542 2.49622C0.417542 3.80872 0.417542 6.62122 0.417542 6.62122C0.417542 6.62122 0.417542 9.40247 0.792542 10.7462C0.980042 11.4962 1.57379 12.0587 2.29254 12.2462C3.63629 12.59 8.98004 12.59 8.98004 12.59C8.98004 12.59 14.2925 12.59 15.6363 12.2462C16.355 12.0587 16.9488 11.4962 17.1363 10.7462C17.5113 9.40247 17.5113 6.62122 17.5113 6.62122C17.5113 6.62122 17.5113 3.80872 17.1363 2.49622ZM7.23004 9.15247V4.08997L11.6675 6.62122L7.23004 9.15247Z",
    fill: "#2AA7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/youTube.97d9462a851b209fa172f31270a2321c.svg";
export { ForwardRef as ReactComponent };